import { render, staticRenderFns } from "./refTMdetails.vue?vue&type=template&id=06380819&scoped=true"
import script from "./refTMdetails.vue?vue&type=script&lang=js"
export * from "./refTMdetails.vue?vue&type=script&lang=js"
import style0 from "./refTMdetails.vue?vue&type=style&index=0&id=06380819&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06380819",
  null
  
)

export default component.exports